import { render } from "./EditUserProfileFormApp.vue?vue&type=template&id=4a5f51a0"
import script from "./EditUserProfileFormApp.vue?vue&type=script&lang=js"
export * from "./EditUserProfileFormApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__